<template>
  <div>
  <!-- navigation -->
 <Navigation> </Navigation>
  <!-- navigation -->

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
<section>
        <div class="container pl-5 pr-5">
            <h2 class=" text-center" style="font-weight: bold; color:#3069B3;"> Tally Plugins - Do More with Tally
                Plugins </h2>
            <p class="text-center text-justify" style="text-align: justify;">
                Are you looking for a feature that is not available in the standard TallyPrime product?
                <br>

                It takes experience with technology and knowledge of business to build effective plugins. And it’s just
                what our developers have been doing over the years.
                <br> Now introducing an exclusive place to buy these Plugins.

            </p>
        </div>
    </section>

    <section>
        <div class="container pl-5 pr-5">
            <div class="row">
                <div class="col-lg-5">
                    <img v-bind:src="'../imgs/img_plugins.png'" class="img-fluid" width="420" height="420">
                </div>
                <div class="col-lg-7">
                    <p class=" lead" style="font-weight: bold;">
                    <p class="text-center" style="margin-top: 50px;"><span class="unlock">Get more</span> <br style="display: block;
   margin: 8px 0;"><sup class="your">advanced</sup> <span class="true">features </span><br> <sup class="business">with
                            our</sup> <sub class="potential" style=""> cutting </sub><br><span
                            class="with">edge</span><span class="tally-erp-9"> Plugins</span></p>


                    </p>
                </div>
            </div>
        </div>
    </section>
<section>
        <div class="container">
            <p>Extensions are new functionality built over default Tally features. You can extend TallyPrime with more
                than 800+ ready-to-plug-in extensions. You can enhance your business by adding a feature, functionality,
                office productivity tools, and so on by adding the extensions available in ‘Tally Shop’</p>
            <p>Choose from an entire range of add-ons across 10 categories such as Invoicing, Workflow Management,
                Business Verticals, Alerts &amp; Controls, and many more. All it takes is ONE CLICK and the Add-on is
                streamed into your PC, installed, licensed and immediately available for use! Buy, Install, Use…in
                seconds!</p>
            <p>Starting from Rs.750, you can now easily locate, evaluate and buy these extensions from Tally Clinic.</p>

            <br>
            <!--  <a href="https://tallysolutions.com/tallyweb/modules/sd/docmgmt/CMktPlaceHomepageWIC.php"><button class="btn-tally-shop">Visit Tally Shop</button> </a> -->
        </div>
    </section>
    <br>
    <br>
    <section style="background-color: #F5F5F5;">
        <div class="container p-5">
            <h2 class="text-center" style="font-weight: bold; color:#3069B3;">Tally – As a Development Platform </h2>
            <br>
            <br>

            <div class="row d-flex justify-content-center">
                <div class="col-lg-4 text-center">
                    <h2 class="lead" style="font-weight: bold; display: inline-block;">Retain the Power of Tally</h2>
                    <p style=" display: inline-block; font-weight: bold; text-align: justify;">Extensions do not impact
                        any of the core features of Tally that you love. You continue to enjoy the speed, simplicity and
                        flexibility of your Tally</p>
                </div>
                <div class="col-lg-4 text-center">
                    <h2 class="lead" style="font-weight: bold;  display: inline-block;">Rapid Development</h2>
                    <p style=" font-weight: bold; text-align: justify;  display: inline-block;">Extend, Customize or
                        Integrate your Tally fast</p>

                </div>
                <div class="col-lg-4 text-center">
                    <h2 class="lead" style="font-weight: bold;  display: inline-block;">Plug and Play</h2>
                    <p style=" font-weight: bold; text-align: justify;  display: inline-block;">Add or remove any
                        extension at any given point of time without compromising data integrity and reliability</p>

                </div>

            </div>

        </div>
    </section>
    <br>
    <br>
    <section class="text-center">
        <h2 class="text-center" style="font-weight: bold; color:#001969;">Categories </h2>
        <br>
        <div class="container">
            <div class="row d-flex justify-content-center">

                <div class="col-lg-2 p-1">
                    <a  style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_receipt.png'" class="img-fluid  mt-5" style="padding-top:20px; margin:auto; display:block;" width="60"
                                    height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Invoicing &amp; Voucher Configuration</h4>

                        </div>
                    </a>
                </div>

                <div class="col-lg-2 p-1 ">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_report.png'" class="img-fluid mt-5" style="padding-top:20px; margin:auto; display:block;" width="60"
                                    height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Reports</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>


                <!--        <div class="col-lg-3 p-1 ">
        <a href="{{ url('/tallygeneral'" style="text-decoration: none; color: #333333;">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_general.png'" class="img-fluid  mt-5" width="60" height="60" />  
        </div>

        <br>
        <h4 style="font-weight: bold;">General</h4>

      </div>
    </a>
      </div>
 -->

                <!--   <div class="col-lg-3 p-1 ">
        <a href="{{ url('/tallyoffprod'" style="text-decoration: none; color: #333333;">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_productivity.png'" class="img-fluid  mt-5" width="60" height="60" /> 
        </div>

        <br>
        <h4 style="font-weight: bold;">Office Productivity</h4>

      </div>
    </a>
      </div> -->

                <div class="col-lg-2 p-1">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_inventory_management.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5"
                                    width="60" height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Inventory Management</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>

                <div class="col-lg-2 p-1 ">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_alert.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                    height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Alerts &amp; Controls</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>

                <div class="col-lg-2 p-1 ">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_work_management.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                    height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Work Flow Management</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>

                <!--  <div class="col-lg-3 p-1 ">
          <a href="{{ url('/tallybanking'" style="text-decoration: none; color: #333333;">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
         <img v-bind:src="'../imgs/ic_banking.png'" class="img-fluid  mt-5" width="60" height="60" />     
        </div>

        <br>
        <h4 style="font-weight: bold;">Banking</h4>

      </div>
    </a>
      </div> -->
                <!--       
      <div class="col-lg-3 p-1 ">
          <a href="{{ url('/tallystatutory'" style="text-decoration: none; color: #333333;">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
         <img v-bind:src="'../imgs/ic_statutory.png'" class="img-fluid  mt-5" width="60" height="60" />     
        </div>

        <br>
        <h4 style="font-weight: bold;">Statutory</h4>

      </div>
    </a>
      </div>
 -->
                <!--  <div class="col-lg-3 p-1 ">
          <a href="{{ url('/tallymanufacturing'" style="text-decoration: none; color: #333333;">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
         <img v-bind:src="'../imgs/ic_manufacturing.png'" class="img-fluid  mt-5" width="60" height="60" />     
        </div>

        <br>
        <h4 style="font-weight: bold;">Manufacturing</h4>

      </div>
    </a>
      </div> -->
            </div>
      <div class="row d-flex justify-content-center">
                <div class="col-lg-2 p-1 ">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_audit.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                    height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Audit</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>

                <div class="col-lg-2 p-1 ">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_voucher_numbering.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5"
                                    width="60" height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Voucher Numbering</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>

                <!-- <div class="col-lg-3 p-1 ">
          <a href="{{ url('/tallyfixedassets'" style="text-decoration: none; color: #333333;">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
         <img v-bind:src="'../imgs/ic_fixed_assets.png'" class="img-fluid  mt-5" width="60" height="60" />     
        </div>

        <br>
        <h4 style="font-weight: bold;">Fixed Assets</h4>

      </div>
    </a>
      </div>
 -->
                <div class="col-lg-2 p-1 ">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_business_verticals.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5"
                                    width="60" height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Business Verticals</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>

                <div class="col-lg-2 p-1 ">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_outst_management.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5"
                                    width="60" height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Outstanding Management</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>

                <div class="col-lg-2 p-1 ">
                    <a href="" style="text-decoration: none; color: #333333;">
                        <div class=" pl-4 pr-3 category-card">
                            <div class="text-center">
                                <img v-bind:src="'../imgs/ic_security.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                    height="60" />
                            </div>

                            <br>
                            <h4 style="font-weight: bold;" class="text-lg">Security</h4>
                            <!--  -->

                        </div>
                    </a>
                </div>


            </div>


        </div>
    </section>
<br>
<br>
    <section class="m-2 p-5 text-center ">
      
        <h2 class="text-center" style="font-weight: bold; color:#001969;">Our Top Plugins</h2>
        <div class="container">
            <div class="row">

                <div class="col-lg-3 p-2">
                    <!-- <img v-bind:src="'../imgs/ic_badge.png'" class="img-fluid "
                        style="position: absolute; right: -10px;  top: -4px;" width="60" height="60"> -->
                    <div class=" pl-4 pr-3 top-prod-card">
                        <div class="text-center">
                            <img v-bind:src="'../imgs/ic_top_addons_autobackup.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5"
                                width="60" height="60">

                        </div>

                        <br>
                        <h4 style="font-weight: bold;" class="text-lg">Auto Backup</h4>


                    </div>
                </div>
                <div class="col-lg-3 p-2 ">
                    <!-- <img v-bind:src="'../imgs/ic_badge.png'" class="img-fluid "
                        style="position: absolute; right: -10px;  top: -4px;" width="60" height="60"> -->
                    <div class=" pl-4 pr-3 top-prod-card">
                        <div class="text-center">
                            <img v-bind:src="'../imgs/ic_top_addons_netrate.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                height="60">
                        </div>
                        <br>
                        <h4 style="font-weight: bold;" class="text-lg">Net Rate</h4>
                    </div>
                </div>


                <div class="col-lg-3 p-2 ">
                    <!-- <img v-bind:src="'../imgs/ic_badge.png'" class="img-fluid "
                        style="position: absolute; right: -10px;  top: -4px;" width="60" height="60"> -->
                    <div class=" pl-4 pr-3 top-prod-card">
                        <div class="text-center">
                            <img v-bind:src="'../imgs/ic_top_addons_negstock.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                height="60">
                        </div>

                        <br>
                        <h4 style="font-weight: bold;" class="text-lg">Negative Stock</h4>


                    </div>
                </div>

                <div class="col-lg-3 p-2 ">
                    <!-- <img v-bind:src="'../imgs/ic_badge.png'" class="img-fluid "
                        style="position: absolute; right: -10px;  top: -4px;" width="60" height="60"> -->
                    <div class=" pl-4 pr-3 top-prod-card">
                        <div class="text-center">
                            <img v-bind:src="'../imgs/ic_top_addons_duplicatesupp.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5"
                                width="60" height="60">
                        </div>

                        <br>
                        <h4 style="font-weight: bold;" class="text-lg">Duplicate Supplier Inventory</h4>


                    </div>
                </div>
                <div class="col-lg-3 p-2 ">
                    <!-- <img v-bind:src="'../imgs/ic_badge.png'" class="img-fluid "
                        style="position: absolute; right: -10px;  top: -4px;" width="60" height="60"> -->
                    <div class=" pl-4 pr-3 top-prod-card">
                        <div class="text-center">
                            <img v-bind:src="'../imgs/ic_addons_two.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                height="60">
                        </div>

                        <br>
                        <h4 style="font-weight: bold;" class="text-lg">HSN &amp; GST Rate Display in Voucher</h4>


                    </div>
                </div>
                <div class="col-lg-3 p-2 ">
                    <!-- <img v-bind:src="'../imgs/ic_badge.png'" class="img-fluid "
                        style="position: absolute; right: -10px;  top: -4px;" width="60" height="60"> -->
                    <div class=" pl-4 pr-3 top-prod-card">
                        <div class="text-center">
                            <img v-bind:src="'../imgs/ic_addons_three.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                height="60">
                        </div>

                        <br>
                        <h4 style="font-weight: bold;" class="text-lg">Return file Cur-Off Date for voucher Alteration</h4>


                    </div>
                </div>
                <div class="col-lg-3 p-2 ">
                    <!-- <img v-bind:src="'../imgs/ic_badge.png'" class="img-fluid "
                        style="position: absolute; right: -10px;  top: -4px;" width="60" height="60"> -->
                    <div class=" pl-4 pr-3 top-prod-card">
                        <div class="text-center">
                            <img v-bind:src="'../imgs/ic_addons_four.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                height="60">
                        </div>

                        <br>
                        <h4 style="font-weight: bold;" class="text-lg">Print Stamp and signature in Invoice</h4>


                    </div>
                </div>

                <div class="col-lg-3 p-2 ">
                    <!-- <img v-bind:src="'../imgs/ic_badge.png'" class="img-fluid "
                        style="position: absolute; right: -10px;  top: -4px;" width="60" height="60"> -->
                    <div class=" pl-4 pr-3 top-prod-card">
                        <div class="text-center">
                            <img v-bind:src="'../imgs/ic_addons_five.png'" style="padding-top:20px; margin:auto; display:block;" class="img-fluid  mt-5" width="60"
                                height="60">
                        </div>

                        <br>
                        <h4 style="font-weight: bold;" class="text-lg">Last Rate Auto Pickup</h4>
                    </div>
                </div>

            </div>
        </div>
    </section>

  </div>
    <section id="faq">
        <div class="container">

            <h2 class="text-center features-heading mt-5">Frequently Asked Questions</h2>

            <!-- <div class="faq-header">Frequently Asked Questions</div> -->

            <div class="faq-content">
                <div class="faq-question">
                    <input id="q1" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q1" class="panel-title">What is the meaning of manage?</label>
                    <div class="panel-content">42</div>
                </div>

                <div class="faq-question">
                    <input id="q2" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q2" class="panel-title">How much wood would a woodchuck chuck?</label>
                    <div class="panel-content">A woodchuck would chuck all the wood he could chuck, if a woodchuck could
                        chuck wood!</div>
                </div>

                <div class="faq-question">
                    <input id="q3" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q3" class="panel-title">What happens if Pinocchio says, "my nose will grow now"?</label>
                    <div class="panel-content">Certain questions are better left &nbsp; <a
                            href="https://en.wikipedia.org/wiki/The_Unanswered_Question" target="_blank">unanswered</a>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <!-- FAQ section - END -->
  </div>
</template>

<script>

    import { Head, Link } from '@inertiajs/inertia-vue3';
    import Navigation from "@/Layouts/Navigation.vue";
    import AppLayout from "@/Layouts/AppLayout.vue";
      import JetNavLink from '@/Jetstream/NavLink.vue'
export default {
 props: {
            canLogin: Boolean,
            canRegister: Boolean,
        },
        components: {
            AppLayout,
            Navigation,
            JetNavLink,
        },
         data() {
        return {
            //url: '/' 
        }
    }
    
}
</script>

<style>
:root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }

    * {
        outline: none;
    }

    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /*Scroll - END*/

    html,
    body {
        max-width: 100%;
        overflow-x: hidden;
    }



        .faq-header {
        font-size: 42px;
        border-bottom: 1px dotted #ccc;
        padding: 24px;
    }

    .faq-content {
        margin: 0 auto;
    }

    .faq-question {
        padding: 20px 0;
        border-bottom: 1px dotted #ccc;
    }

    .panel-title {
        font-size: 18px;
        width: 100%;
        position: relative;
        margin: 0;
        padding: 10px 10px 0 48px;
        display: block;
        cursor: pointer;
    }

    .panel-content {
        font-size: 20px;
        padding: 0px 14px;
        margin: 0 40px;
        height: 0;
        overflow: hidden;
        z-index: -1;
        position: relative;
        opacity: 0;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.panel-content {
        height: auto;
        opacity: 1;
        padding: 14px;
    }

    .plus {
        position: absolute;
        margin-left: 20px;
        margin-top: 13px;
        z-index: 5;
        font-size: 20px;
        line-height: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.plus {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .panel {
        display: none;
    }

    	.mobile-section-h3{
    	color: #333;
		font-weight: 600;
    }

     .unlock {
            font-size: 7.9vh;
            margin-right: 12vw;
            line-height: 40px;
            color: #333333;
        }

        .your {
            font-size: 4.0vh;
            margin-left: 35px;
            line-height: 39px;

        }

        .business {
            font-size: 5.2vh;
            margin-left: 48px;
            line-height: 40px;
        }

        .true {
            font-size: 6.5vh;
            font-weight: bolder;
        }

        .potential {
            font-size: 6.5vh;

        }

        .tally-erp-9 {
            font-size: 7.9vh;
            color: #FE9E38;
            font-weight: bolder;
        }

        .with {
            font-size: 3.99vh;
            font-weight: bolder;
        }

         .btn-tally-shop {
            padding: 10px;
            border: 0px solid #333;
            background-color: #FFC632;
            border-radius: 100px;
            color: #333;
            font-weight: bold;
        }

                /*.category-card{
      border: 1px solid #CECECE;
      border-radius: 10px;
      background-color:#03A9F4; 
      box-shadow: 0px 0px 8px 2px #CECECE;
      transition: 0.3s;
    }*/

        .category-card:hover {
            box-shadow: 0px 0px 10px 2px #233f9c;
        }

        /* Extra small devices (phones, 600px and down) */
        @media only screen and (max-width: 600px) {
            .category-card {
                /*border: 1px solid #CECECE;*/
                border-radius: 5px;
                background-color: #001969;
                /*box-shadow: 0px 0px 8px 2px #CECECE;*/
                transition: 0.2s;
                height: 180px;
                color:white;

            }
        }

        /* Small devices (portrait tablets and large phones, 600px and up) */
        @media only screen and (min-width: 600px) {
            .category-card {
                /*border: 1px solid #CECECE;*/
                border-radius: 5px;
                background-color: #001969;
                /*box-shadow: 0px 0px 8px 2px #CECECE;*/
                transition: 0.2s;
                height: 200px;
                color:white;

            }
        }

        /* Medium devices (landscape tablets, 768px and up) */
        @media only screen and (min-width: 768px) {
            .category-card {
                /*border: 1px solid #CECECE;*/
                border-radius: 5px;
                background-color: #001969;
                /*box-shadow: 0px 0px 8px 2px #CECECE;*/
                transition: 0.2s;
                height: 200px;
                color:white;

            }
        }

        /* Large devices (laptops/desktops, 992px and up) */
        @media only screen and (min-width: 992px) {
            .category-card {
                /*border: 1px solid #CECECE;*/
                border-radius: 5px;
                background-color: #001969;
                /*box-shadow: 0px 0px 8px 2px #CECECE;*/
                transition: 0.2s;
                color:white;

                height: 200px;
            }
        }

        /* Extra large devices (large laptops and desktops, 1200px and up) */
        @media only screen and (min-width: 1200px) {
            .category-card {
                /*border: 1px solid #CECECE;*/
                border-radius: 5px;
                background-color: #001969;
                /*box-shadow: 0px 0px 8px 2px #CECECE;*/
                transition: 0.2s;
                color:white;
                height: 200px;
            }
        }

        .category-icons {
            font-size: 350%;
            color: #CDD5D8;
        }

          .top-prod-card {
            /*border: 1px solid #CECECE;*/
            border-radius: 5px;
            margin: auto;
            height: 170px;
            background-color: #001969;
            /*box-shadow: 0px 0px 8px 2px #CECECE;*/
            color: #FFFFFF;
            transition: 0.3s;
            padding-bottom: 3px;
        }

        /* .top-prod-card:hover {
            background-color: #fce723;
            color: #333333;
            box-shadow: 0px 0px 8px 3px #CECECE;
        } */

    </style>
